import { useState, useEffect } from "react"
import ApiUser from "services/api-user"
import { useSelector } from "react-redux"

const useCurrentUser = () => {
  const userData = useSelector((state) => state.userReducer.userData) || {}

  const userId = userData.idUser
  const [currentUser, setCurrentUser] = useState({})

  useEffect(() => {
    async function fetchCurrentUserData() {
      const response = await ApiUser.getItem(userId)
      setCurrentUser(response.data)
    }
    fetchCurrentUserData()
  }, [userId])

  return currentUser
}

export default useCurrentUser
